import React, { useGlobal } from 'reactn';
import palette from 'theme/palette';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';
import { makeStyles } from '@material-ui/styles';
import moment from 'moment';
import * as API from '../../../../api/api';
import { IconButton } from '@material-ui/core';
import { Card, CardHeader, CardContent, Divider } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';

import { options } from './chart';
import localization from 'moment/locale/nl';
moment.updateLocale('nl', localization);

const useStyles = makeStyles(() => ({
  root: {},
  chartContainer: {
    height: 400,
    position: 'relative'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const LatestSales = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const [system] = useGlobal('system');

  const aantalPerDag = [];
  const dagen = [];

  if (system?.events?.length) {
    system.events.forEach(ev => {
      aantalPerDag.push(ev.total);
      dagen.push(moment(ev._id).format('D MMM'));
    });
  }

  const refreshData = () => {
    API.getSystem();
  };

  // ------ Chart.js v3 migration helpers ------
  const getAxisCfg = () => {
    const ox =
      options?.scales?.xAxes?.[0] ||
      options?.scales?.x ||
      {};
    const oy =
      options?.scales?.yAxes?.[0] ||
      options?.scales?.y ||
      {};
    return { ox, oy };
  };

  const { ox, oy } = getAxisCfg();

  const datasetBarPercentage =
    (ox && ox.barPercentage) ??
    (oy && oy.barPercentage);
  const datasetCategoryPercentage =
    (ox && ox.categoryPercentage) ??
    (oy && oy.categoryPercentage);
  const datasetBarThickness =
    (ox && ox.barThickness) ??
    (oy && oy.barThickness);
  const datasetMaxBarThickness =
    (ox && ox.maxBarThickness) ??
    (oy && oy.maxBarThickness);

  // Strip deprecated velden uit options voordat we renderen
  const sanitizedOptions = (() => {
    const clone = {
      ...options,
      scales: options?.scales ? { ...options.scales } : undefined
    };

    const stripAxis = (axisCfg) => {
      if (!axisCfg) return axisCfg;
      const c = { ...axisCfg };
      if ('barPercentage' in c) delete c.barPercentage;
      if ('categoryPercentage' in c) delete c.categoryPercentage;
      if ('barThickness' in c) delete c.barThickness;
      if ('maxBarThickness' in c) delete c.maxBarThickness;
      return c;
    };

    // v2-stijl arrays
    if (clone.scales?.xAxes?.length) {
      clone.scales.xAxes = clone.scales.xAxes.map(stripAxis);
    }
    if (clone.scales?.yAxes?.length) {
      clone.scales.yAxes = clone.scales.yAxes.map(stripAxis);
    }

    // v3-stijl objecten
    if (clone.scales?.x) clone.scales.x = stripAxis(clone.scales.x);
    if (clone.scales?.y) clone.scales.y = stripAxis(clone.scales.y);

    return clone;
  })();

  const data = {
    labels: dagen,
    datasets: [
      {
        label: 'Aantal acties',
        backgroundColor: palette.primary.main,
        data: aantalPerDag,
        // Chart.js v3+: zet sizing/percentages op de dataset
        ...(datasetBarPercentage !== undefined ? { barPercentage: datasetBarPercentage } : {}),
        ...(datasetCategoryPercentage !== undefined ? { categoryPercentage: datasetCategoryPercentage } : {}),
        ...(datasetBarThickness !== undefined ? { barThickness: datasetBarThickness } : {}),
        ...(datasetMaxBarThickness !== undefined ? { maxBarThickness: datasetMaxBarThickness } : {})
      }
    ]
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        action={
          <IconButton size="small" onClick={refreshData}>
            <RefreshIcon />
          </IconButton>
        }
        title="Acties per dag"
      />
      <Divider />
      <CardContent>
        <div className={classes.chartContainer}>
          <Bar
            data={data}
            options={sanitizedOptions}
          />
        </div>
      </CardContent>
    </Card>
  );
};

LatestSales.propTypes = {
  className: PropTypes.string
};

export default LatestSales;
